import { WPS_ThicknessTable } from "./WPS_ThicknessTable";

export const WPS_Thickness_overlay = ({ headerObj, error, isReadonly, handleChange, setError }) => {
  const rows = [
    { label: 'Base Metal CRO', minField: 'WPSH_TRQ_BaseMetalCRO_Min', maxField: 'WPSH_TRQ_BaseMetalCRO_Max' },
    { label: 'Base Metal HRO', minField: 'WPSH_TRQ_BaseMetalHRO_Min', maxField: 'WPSH_TRQ_BaseMetalHRO_Max' }
  ];

  return (
    <WPS_ThicknessTable
      headerObj={headerObj}
      error={error}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      rows={rows}
    />
  );
};
